export default {
  products_home: '产品服务',
  get_started_uppercase: '立即开始',
  documentation_home: '文档中心',

  products: '产品',
  multiplayer: '多人对战',
  social: '互动社交',
  content_footer: '内容更新',
  economy: '经济系统',
  analytics: '数据分析',
  engagement: '玩家参与',
  resources: '资源',
  docs: '文档中心',
  support: '支持',
  contact_us_footer: '联系我们',
  contact_for_product: '获取产品最新动态与商业合作方式',
  we_are_online: '关于InGame',
  search_all: '搜索所有服务',
  no_search_result: '没有搜索结果',
  document_center: '文档中心',
};
